<template>
  <div></div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    data() {
        return {
            userId: this.$route.params.userId,
            browserLocale: null,
        }
    },
    created() {
        this.handleInit();
    },
    mounted() {
        this.deleteLogoutSite();
        this.initSso();
    },
    methods : {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        /* 다국어 & 망구분(내/외/모바일) */
        handleInit() {
            let obj = this;
            /* 다국어 설정(브라우저 언어 별) */
            let locale = navigator.language || navigator.userLanguage;
            locale = locale.substring(0, 2);
            if (locale !== "ko") {
                locale = "en";
            }
            obj.browserLocale = locale;
            obj.$i18n.locale = locale;
        },
        initSso() {
            let obj = this;
            let reqData = {
                url: "/api/auth/hcpsso/login",
                method: "post",
                params: {
                    userId: obj.userId,
                }
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if (res.errorCode) {
                    console.log(res.errorCode);
                    if(res.errorCode == 'UG001'){
                        obj.$router.push("/hcpsso/sso_login");
                    }
                } else {
                    localStorage.setItem("tenantId", res.result.tenantId);
                    localStorage.setItem("userId", res.result.userId);
                    localStorage.setItem("userName", res.result.userName);
                    localStorage.setItem("deptName", res.result.deptName);
                    localStorage.setItem("okrUse", res.result.okrUse);
                    localStorage.setItem("isManager", res.result.isManager);
                    localStorage.setItem("accessType", res.result.accessType);
                    localStorage.setItem("sharUse", res.result.sharUse);
                    localStorage.setItem("cfrcUse", res.result.cfrcUse);
                    localStorage.setItem("boardHashTagUse", res.result.boardHashTagUse);
                    localStorage.setItem("boardAllListUse", res.result.boardAllListUse);
                    localStorage.setItem("autoInvite", res.result.autoInvite);
                    localStorage.setItem("i18nUse", res.result.i18nUse);
                    localStorage.setItem("pinBlockYn", res.result.pinBlockYn);
                    localStorage.setItem("announcementUseYn", res.result.announcementUseYn);
                    let locale = res.result.locale;
                    if (locale === 'ko' || locale === 'en') {
                        obj.$i18n.locale = locale + "-" + res.result.tenantId;
                        locale = locale + "-" + res.result.tenantId;
                    } else {
                        obj.$i18n.locale = obj.browserLocale + "-" + res.result.tenantId;
                        locale = obj.browserLocale + "-" + res.result.tenantId;
                    }                                    
                    localStorage.setItem("defaultLanguage", locale);

                    // 한화생명 자격증명
                    rtcrossexInst.login(res.result.userId);
                    
                    setTimeout(()=> {
                        if (!res.result.isIntro) {
                            obj.$router.push("/general/intro");
                        } else {
                            obj.$router.push("/general/home");
                        }
                    }, rtcrossexInst.loginDelayTime);
                }
            })
            .catch(function(err) {
                console.log(err);
            })
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/sso/hcp/hcpSsoRedirect.vue